'use client';

import { FloatingPortal } from '@floating-ui/react';
import { useContext } from 'react';

import { ComboboxRootContext } from './context/combobox-root.context';
import type { ComboboxPortalPropsInterface } from './types/combobox-portal.types';

/**
 * @since 10.0.0
 */
export const ComboboxPortal = (props: ComboboxPortalPropsInterface) => {
  const { combobox } = useContext(ComboboxRootContext);

  if (!combobox.isMounted) {
    return null;
  }

  return <FloatingPortal {...props} />;
};

ComboboxPortal.displayName = 'Combobox.Portal';
